import { useEffect } from 'react';
import { useAppStore } from '../../store';
import { useTasksByStatus, moveToTrack } from '../../hooks/useTasks';
import { queryClient } from '../../api/queryClient';
import { BacklogCanvas } from './BacklogCanvas';
import { QuickAdd } from '../shared/QuickAdd';
import type { Task } from '../../types';
import { getTodayIso } from '../../lib/dateScope';

export function BacklogView() {
  const setHeaderContext = useAppStore((s) => s.setHeaderContext);
  const tasks = useTasksByStatus('backlog');
  const parentTasks = tasks.filter((t) => !t.parentId);

  useEffect(() => {
    setHeaderContext({ count: parentTasks.length, label: 'items' });
    return () => setHeaderContext(null);
  }, [parentTasks.length, setHeaderContext]);

  const spaceId = useAppStore((s) => s.currentSpaceId);

  const handleMoveToTrack = async (task: Task) => {
    await moveToTrack(task.id, getTodayIso());
    queryClient.invalidateQueries({ queryKey: ['tasks', spaceId, 'backlog'] });
    queryClient.invalidateQueries({ queryKey: ['tasks', spaceId, 'track'] });
  };

  return (
    <div className="flex flex-col h-[calc(100vh-48px)]">
      <div className="flex items-center justify-between px-6 py-3 border-b border-border-subtle">
        <div>
          <h2 className="text-headline text-text-primary">Backlog</h2>
          <p className="text-caption text-text-muted mt-0.5">
            {parentTasks.length} {parentTasks.length === 1 ? 'item' : 'items'}
          </p>
        </div>
        <QuickAdd placeholder="Add to backlog..." />
      </div>
      <div className="flex-1">
        <BacklogCanvas tasks={parentTasks} onMoveToTrack={handleMoveToTrack} />
      </div>
    </div>
  );
}
